import { MonitorCog } from "lucide-react";
import MainBody from "./components/MainBody/MainBody";
import { Card, CardContent } from "./components/ui/card";

const WorkProgress = ({ expandList = false, popup = false }) => {
  return (
    <MainBody search={false} className="p-0" expandList={expandList} parentHeight={true}>
      <div className="flex h-full min-h-[calc(100vh-135px)] items-center justify-center p-4">
        <Card className="max-w-md w-full shadow-lg text-center">
          <CardContent className="flex flex-col items-center gap-4 py-10">
            <MonitorCog className="h-12 w-12 text-yellow-500" />
            <h2 className="text-2xl font-semibold ">Work Inprogress</h2>
            {/* <p>You do not have permission to view this page.</p> */}
            {/* {!popup && <Button variant="outline" onClick={() => navigate(-1)}>
                Go Back
              </Button>} */}
          </CardContent>
        </Card>
      </div>
    </MainBody>
  );
};

export default WorkProgress;
